<template>
  <span class="anticon">
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.78906 2.64355C7.06819 2.69309 7.29502 2.90944 7.35254 3.19531L8.18652 7.3623C8.23242 7.59181 8.16061 7.82962 7.99512 7.99512L5.65039 10.3389C6.1271 11.1984 6.70385 11.9636 7.37012 12.6299C8.03624 13.2959 8.80094 13.872 9.66016 14.3486L12.0049 12.0049L12.0703 11.9473C12.2296 11.8235 12.4361 11.7735 12.6367 11.8135L16.8037 12.6465C17.1308 12.7119 17.3661 12.9995 17.3662 13.333V16.666C17.3662 17.0526 17.0526 17.3662 16.666 17.3662C12.3595 17.3661 8.83158 16.0716 6.37988 13.6201C3.92826 11.1683 2.63281 7.63984 2.63281 3.33301C2.63299 2.94667 2.94667 2.63299 3.33301 2.63281H6.66602L6.78906 2.64355ZM11.0068 14.9824C12.4507 15.5532 14.1084 15.8855 15.9668 15.9521V13.9062L12.7295 13.2598L11.0068 14.9824ZM4.0459 4.0332C4.11251 5.89113 4.446 7.54855 5.0166 8.99219L6.73926 7.26953L6.0918 4.0332H4.0459Z" fill="black" fill-opacity="0.65"/>
    </svg>
  </span>
</template>
<script>
export default {
  name: "PhoneIcon",
};
</script>

<style lang="sass" scoped></style>
